import { useRef, useEffect, useContext, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";
import context from "../../store/context";

import TendersLayout from "./TendersLayout";
import DateConverter from "../../components/DateConverter";
import TimeDifference from "../../components/TimeDifference";
import SaveUnsave from "../../components/Buttons/SaveUnsave";
import TenderDetailShimmer from "./TenderDetailShimmer";
import DetailHTML from "./DetailHTML";
import TenderContentPlaceholder from "../../components/cards/TenderContentPlaceholder";
import CompanyInfo from "../../components/cards/CompanyInfo";
import CompanyInfoShimmer from "../../components/cards/CompanyInfoShimmer";

// icons
import BackIcon from "../../components/icons/Back";
import TagIcon from "../../components/icons/Tag";
import CalendarIcon from "../../components/icons/Calendar";

const TenderDetail = () => {
  const {
    setShowTenderDetail,
    prevRoute,
    setShouldLoadTenders,
    tendersCategoryLists,
    getCategories,
    tendersRegions,
    tendersLanguage,
    getLanguagesAndRegions,
  } = useContext(context);

  useEffect(() => {
    if (tendersCategoryLists.length === 0) {
      getCategories("");
    }
    if (tendersRegions.length === 0 || tendersLanguage.length === 0) {
      getLanguagesAndRegions("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [isFetching, setIsFetching] = useState(false);
  const [response, setResponse] = useState({});
  const params = useParams();
  const navigate = useNavigate();

  const userToken = sessionStorage.getItem("token");

  useEffect(() => {
    var headers = new Headers();
    headers.append("X-XSRF-TOKEN", "csrf-cookie");
    headers.append("Accept", "application/json");
    headers.append("Authorization", `Bearer ${userToken}`);

    var requestOptions = {
      method: "GET",
      headers: headers,
      redirect: "follow",
    };
    setIsFetching(true);

    fetch(
      `https://api.ichereta.com/api/tender/detail/${params.tenderId}`,
      requestOptions
    )
      .then((response) => {
        if (response.status === 401) {
          sessionStorage.clear();
          window.location.href = "/";
        }
        return response.json();
      })
      .then((result) => {
        setResponse(result.data);
        setIsFetching(false);
        // console.log(result.data.content);
      })
      .catch((error) => {
        setIsFetching(false);
        console.log("error", error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const currentTime = new Date();
  const isBackPressedRef = useRef(false);

  const setIsBackPressed = (value) => {
    isBackPressedRef.current = value;
  };

  useEffect(() => {
    setShouldLoadTenders(false);

    return () => {
      if (!isBackPressedRef.current) {
        setShouldLoadTenders(true);
      }
    };
  }, [setShouldLoadTenders]);

  const handleGoBack = () => {
    setIsBackPressed(true);
    setShowTenderDetail(true);
    navigate(prevRoute);
  };

  const redirect = () => {
    navigate("/");
  };

  const notAUser = "Login or Subscribe";

  return (
    <TendersLayout showSearchSidebar={true} redirect={true} filter={""}>
      <div className="w-full h-full overflow-y-auto flex flex-col items-start p-2 sm:p-5 space-y-8 text-[#3d5984]">
        {isFetching ? (
          <TenderDetailShimmer />
        ) : (
          <div className="flex flex-col items-start space-y-2 w-full">
            <div className="flex w-full justify-between">
              <button
                onClick={handleGoBack}
                className="flex items-center justify-center gap-2 text-xs font-semibold px-3 py-1.5 rounded-full bg-gray-50 text-[#664bc7] ring-1 ring-gray-200 hover:bg-[#664bc7]/10 hover:ring-[#664bc7]/20 transition-colors"
              >
                <BackIcon styles="w-5 h-5" /> <span>Back</span>
              </button>
              <div className="flex items-center space-x-2 ">
                <SaveUnsave
                  navigate={redirect}
                  isSavedDB={response.is_saved}
                  id={response.id}
                />
              </div>
            </div>
            <div className="bg-white w-full rounded-2xl p-4 sm:p-5 border border-gray-200/70 shadow-[0_2px_10px_rgba(61,89,132,0.08)]">
              <div className="flex flex-col items-start gap-2 w-full">
                <h1 className="text-base sm:text-lg font-semibold leading-snug text-start w-full">
                  {response.title}
                </h1>
                <span
                  className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-semibold ring-1 ${
                    Number(response.status) === 1
                      ? "bg-green-50 text-green-600 ring-green-600/20"
                      : "bg-red-50 text-red-500 ring-red-500/20"
                  }`}
                >
                  <CalendarIcon styles="w-3.5 h-3.5" />
                  {Number(response.status) === 1
                    ? "BIDDING OPEN"
                    : "BIDDING CLOSED"}
                </span>
              </div>

              <div className="w-full h-px bg-gray-100 my-3" />

              <div className="flex flex-col gap-2.5 text-xs sm:text-sm items-start w-full overflow-hidden">
                <div className="flex items-start gap-2">
                  <h1 className="font-medium text-[#3d5984]/60 min-w-max">
                    Bid Closing Date:
                  </h1>
                  {userToken ? (
                    response.alternative_close_date ? (
                      <span className="text-start font-medium">
                        {response.alternative_close_date}{" "}
                      </span>
                    ) : response.bid_close_date ? (
                      <DateConverter dateString={response.bid_close_date} />
                    ) : (
                      ""
                    )
                  ) : (
                    <span>{notAUser}</span>
                  )}
                </div>
                <div className="flex items-start gap-2">
                  <h1 className="font-medium text-[#3d5984]/60 min-w-max">
                    Bid Opening Date:
                  </h1>

                  {userToken ? (
                    response.alternative_open_date ? (
                      <span className="text-start font-medium">
                        {response.alternative_open_date}
                      </span>
                    ) : response.bid_open_date ? (
                      <DateConverter dateString={response.bid_open_date} />
                    ) : (
                      ""
                    )
                  ) : (
                    <span>{notAUser}</span>
                  )}
                </div>

                <div className="flex items-start gap-2">
                  <h1 className="font-medium text-[#3d5984]/60 min-w-max">
                    Published On:
                  </h1>
                  <div className="flex flex-wrap font-medium">
                    {userToken ? (
                      response.tender_sources ? (
                        response.tender_sources.map((publisher, index) => {
                          return (
                            <div
                              className="text-start flex items-start gap-2"
                              key={publisher.source.id}
                            >
                              {index !== 0 && <span>,</span>}
                              <span className="min-w-max">
                                {publisher.source.name}
                              </span>
                              <div className="flex">
                                <span>{`(`}</span>
                                <DateConverter
                                  dateString={publisher.published_at}
                                />
                                <span>{`)`}</span>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        ""
                      )
                    ) : (
                      <span>{notAUser}</span>
                    )}
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <span className="font-medium text-[#3d5984]/60">Posted:</span>
                  <span className="font-medium">
                    <TimeDifference
                      currentTime={currentTime}
                      dateString={response.created_at}
                    />
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="font-medium text-[#3d5984]/60">
                    Bid Document Price:
                  </span>
                  <span className="font-medium">
                    {userToken
                      ? response.bid_doc_price
                        ? `${response.bid_doc_price}`
                        : ""
                      : notAUser}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="font-medium text-[#3d5984]/60">
                    Bid Bond Price:
                  </span>
                  <span className="font-medium">
                    {userToken
                      ? response.bid_bond_price
                        ? `${response.bid_bond_price}`
                        : ""
                      : notAUser}
                  </span>
                </div>

                <div className="py-5 border-y border-gray-100 flex break-words w-full overflow-x-auto text-sm break-all">
                  {response.content ? (
                    <DetailHTML htmlString={response.content} />
                  ) : (
                    <TenderContentPlaceholder snippet={response.snippet} />
                  )}
                </div>

                <div className="flex flex-wrap items-center gap-2.5 pt-1">
                  {response.tender_categories &&
                    response.tender_categories.map((category, index) => {
                      return (
                        <div
                          key={`${category.category_id}-${index}`}
                          className="flex items-center gap-1.5 border border-[#3d5984]/15 bg-[#3d5984]/5 text-[#3d5984]/80 px-3 py-1 rounded-full text-xs"
                        >
                          <TagIcon styles="w-4 h-4" />
                          <span>{category.category.name}</span>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          </div>
        )}

        {isFetching ? (
          <CompanyInfoShimmer />
        ) : (
          response.company && (
            <CompanyInfo
              src={response.company.logo}
              name={response.company.name}
              id={response.company.id}
            />
          )
        )}
      </div>
    </TendersLayout>
  );
};

export default TenderDetail;
